import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { MainCompetitorWrapper } from "app/pages/activation/components/Settings/Competitors/MainCompetitor/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon, red, bluegrey, midnight } = colorsPalettes;

export const EditSettingsMainCompetitorWrapper = styled.div`
    padding: 8px 0;

    &:not(:last-child) {
        border-bottom: 1px solid ${carbon[50]};
    }
`;

export const EditSettingsMainCompetitorContentWrapper = styled(FlexRow)`
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;

    ${MainCompetitorWrapper} {
        padding: 0;
        margin: 0;
        flex-grow: 1;
    }

    .main-competitor-tooltip {
        display: block;
        flex-grow: 1;
    }
`;

export const EditSettingsDeleteButtonWrapper = styled.div`
    cursor: pointer;
`;

export const MessageWarning = styled(FlexRow)<{ isVisible: boolean }>`
    background-color: ${red[100]};
    border-radius: 4px;
    padding: 8px 11px;
    gap: 8px;
    align-items: center;
    width: 500px;
    box-sizing: border-box;
    ${setFontVariant("body2", carbon[400])};

    ${({ isVisible }) =>
        !isVisible
            ? css`
                  display: none;
              `
            : null}
`;

export const MessageInfo = styled(FlexRow)<{ isVisible: boolean }>`
    background-color: ${bluegrey[200]};
    border: 1px solid ${midnight[50]};
    border-radius: 3px;
    align-items: center;
    padding: 8px 8px 8px 16px;
    width: 500px;
    height: 40px;
    box-sizing: border-box;
    ${setFontVariant("input2", carbon[400])};

    ${({ isVisible }) =>
        !isVisible
            ? css`
                  display: none;
              `
            : null}
`;

export const AlertIcon = styled(SWReactIcons)`
    path {
        fill: ${red["s100"]};
    }
`;
